import React from 'react'
import CustomerSupportPhone from '../../../Account/CustomerSupportPhone';
import CustomerSupportEmail from '../../../Account/CustomerSupportEmail';
import './NoQuoteAvailable.scss'

export default function NoQuoteAvailable(props) {
  
  const phoneNumber = CustomerSupportPhone();
  const emailAddress = CustomerSupportEmail();

  return (
    <div className="no-quote-container">
      <h5>No quotes available</h5>
      {props.subText &&
        <div>
          <p> {props.subText}</p>
            <React.Fragment>
              <p>Email us at <a href={`mailto:${emailAddress}`}>{emailAddress}</a></p>
              <p>Please call us at <a href={`tel:${phoneNumber}` }>{phoneNumber}</a></p>
            </React.Fragment>
        </div>
      }
    </div>
  )
}